import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { KeyNumber } from 'qp-navigation';
import { AspectRatio, ContainerVm, ResourceVm } from 'qp-ui-interface';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';
import { RoutingService } from '../../services/routing/routing.service';
import { ScreenService } from '../../services/screen/screen.service';
import { validateToPlay } from '../../utils/playerUtils';
@Component({
  selector: 'app-grid-carousel',
  templateUrl: './grid-carousel.component.html',
  styleUrls: ['./grid-carousel.component.scss'],
})
export class GridCarouselComponent {
  @ViewChild('gridCarousel') gridCarousel: ElementRef;
  @Input() width = '92vw';
  @Input() height = 'auto';
  @Input() aspectRatio = '2x3' as AspectRatio;
  @Input() cardSize: 'small' | 'normal' = 'normal';
  @Input() data!: ContainerVm;
  @Input() leftComponent = 'tv-menu';
  @Input() rightComponent = 'tv-menu';
  @Input() topComponent = 'tv-menu';
  @Input() classId = '';
  @Input() showCardsTitle = false;
  @Input() title;
  @Input() restartData: boolean;
  @Input() saveUrl = false;
  @Output() nextPage = new EventEmitter();

  private isNavigating = false;
  constructor(
    private readonly routingService: RoutingService,
    private readonly navService: NavigationLibraryService,
    private readonly screenService: ScreenService,
    private readonly location: Location
  ) {}

  pagination(event: KeyboardEvent): void {
    if (event.keyCode == KeyNumber.DOWN) {
      this.nextPage.emit();
    }
  }

  async onSelectedCardChanged(item: ResourceVm): Promise<void> {
    if (this.isNavigating) {
      return;
    }
    this.isNavigating = true;
    if (this.saveUrl) this.screenService.searchlink = this.location.path();
    if (validateToPlay(item.type)) {
      await this.routingService.navigateToPlayerWithValidations(item, false);
    } else {
      await this.routingService.navigateToDetails(item, this.data);
    }
    this.isNavigating = false;
  }

  focusChange() {
    this.navService.alignActiveElement(this.gridCarousel);
  }
}
